let configurePromise = null;
let authModulePromise = null;
let oauthListenerPromise = null;

const loadAmplify = () => import("aws-amplify");
const loadAuthConfig = () => import("Components/Auth/amplifyConfig");
const loadOAuthListener = () => import("aws-amplify/auth/enable-oauth-listener");

const ensureOAuthListenerLoaded = async () => {
  if (typeof window === "undefined") {
    return;
  }

  if (!oauthListenerPromise) {
    oauthListenerPromise = loadOAuthListener().catch((error) => {
      oauthListenerPromise = null;
      throw error;
    });
  }

  await oauthListenerPromise;
};

export const ensureAmplifyConfigured = async () => {
  if (!configurePromise) {
    configurePromise = Promise.all([loadAmplify(), loadAuthConfig()])
      .then(([amplifyModule, authConfigModule]) => {
        const { Amplify } = amplifyModule;
        const { getAuthConfig } = authConfigModule;
        Amplify.configure(getAuthConfig());
      })
      .then(() => ensureOAuthListenerLoaded())
      .catch((error) => {
        configurePromise = null;
        throw error;
      });
  }

  return configurePromise;
};

export const loadAmplifyAuth = async () => {
  await ensureAmplifyConfigured();
  if (!authModulePromise) {
    authModulePromise = import("aws-amplify/auth").catch((error) => {
      authModulePromise = null;
      throw error;
    });
  }
  return authModulePromise;
};

export const signOutUser = async (input) => {
  const authModule = await loadAmplifyAuth();
  return authModule.signOut(input);
};
